// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1JFv4","checkboxCol":"Table_checkboxCol__q6WNC","emailCol":"Table_emailCol__2Uwll","actionCol":"Table_actionCol__2Hktj"};